import { createSlice } from "@reduxjs/toolkit";
import { UserBrand } from "types/users";
import { fetchUserBrands, fetchUserBrandsWithStrategy } from "./thunk";

export interface UserBrands {
    items: UserBrand[],
    items_with_strategy: UserBrand[],
    loading: boolean,
    loading_with_strategy: boolean,
    error: string | null,
    last_fetched_at: number|null
}

const initialState: UserBrands = {
    items: [],
    items_with_strategy: [],
    loading: false,
    loading_with_strategy: false,
    error: null,
    last_fetched_at: null
}

const userBrand = createSlice({
    name: 'userBrands',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchUserBrands.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchUserBrands.fulfilled, (state, action) => {
            state.items = action.payload;
            state.last_fetched_at = Date.now();
            state.error = null;
            state.loading = false;
        })
        .addCase(fetchUserBrands.rejected, (state, action) => {
            state.error = action.payload ?? 'Failed to fetch user brands';
            state.loading = false;
        })
        .addCase(fetchUserBrandsWithStrategy.pending, (state) => {
            state.loading_with_strategy = true;
            state.error = null;
        })
        .addCase(fetchUserBrandsWithStrategy.fulfilled, (state, action) => {
            state.items_with_strategy = action.payload;
            state.error = null;
            state.loading_with_strategy = false;
        })
        .addCase(fetchUserBrandsWithStrategy.rejected, (state, action) => {
            state.error = action.payload ?? 'Failed to fetch user brands with strategy';
            state.loading_with_strategy = false;
        })
    }
})

export default userBrand.reducer;